import script from "./AppSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppSidebar.vue?vue&type=script&lang=ts&setup=true"

import "./AppSidebar.vue?vue&type=style&index=0&id=7dd0aaec&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dd0aaec"]])

export default __exports__